module.exports = __webpack_public_path__ + "img/florin-sign.0b0b95ed.svg";